enum DocumentType {
    DDT = "DDT",
    INVOICE = "INVOICE",
    CREDITNOTE = "CREDITNOTE",
    DEBITNOTE = "DEBITNOTE"
}
export default DocumentType;
